import { Routes, Route, Navigate } from 'react-router-dom';
import { useOdoo } from './context/OdooContext.js';
import LoginScreen from './screens/00-auth-login/LoginScreen.js';
import DashboardScreen from './screens/01-dashboard/DashboardScreen.js';
import ProjectOverviewScreen from './screens/02-project-overview/ProjectOverviewScreen.js';
import LotsTableScreen from './screens/03-lots-table/LotsTableScreen.js';
import LotDetailScreen from './screens/04-lot-detail/LotDetailScreen.js';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { client } = useOdoo();
  if (!client) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/" element={<RequireAuth><DashboardScreen /></RequireAuth>} />
      <Route path="/projects/:id" element={<RequireAuth><ProjectOverviewScreen /></RequireAuth>} />
      <Route path="/projects/:id/lots" element={<RequireAuth><LotsTableScreen /></RequireAuth>} />
      <Route path="/projects/:id/lots/:lotCode" element={<RequireAuth><LotDetailScreen /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
